import React from "react";
import photo from "../../assets/images/user4.jpg";
import { IMemberListData } from "../../exports/interfaces";

const ListMemberTable = (props: { listMemberData: IMemberListData[] }) => {
  return (
    <section className="cart-page">
      <div className="container">
        <div className="section-title custom-text-center">
          <h2 className="section-title__title">FIND SURGEON NEAR YOU</h2>
        </div>
        <div className="table-responsive">
          <table className="table cart-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Designation</th>
                <th>Specialization</th>
                <th>Location</th>
              </tr>
            </thead>
            <tbody>
              {props?.listMemberData?.map((data, index) => (
                <tr
                  key={index}
                  style={{
                    backgroundColor: index % 2 !== 0 ? "#f2f0ec" : "unset",
                  }}
                >
                  <td>
                    <div className="product-box">
                      <div className="img-box">
                        {data?.attributes?.Profile_Picture?.data !== null &&
                        data?.attributes?.Profile_Picture?.data !==
                          undefined ? (
                          <img
                            src={`${process.env.REACT_APP_strapiUrl}${data?.attributes?.Profile_Picture?.data?.attributes?.url}`}
                            alt="member"
                            style={{
                              width: "120px",
                              height: "120px",
                              objectFit: "cover",
                            }}
                          />
                        ) : (
                          <img
                            src={photo}
                            alt="member"
                            style={{
                              width: "120px",
                              height: "120px",
                              objectFit: "cover",
                            }}
                          />
                        )}
                      </div>
                      <h3>
                        <a href="/">{data?.attributes?.First_Name}</a>
                      </h3>
                    </div>
                  </td>
                  <td>{data?.attributes?.Designation}</td>
                  <td>{data?.attributes?.Qualifications}</td>
                  <td>{data?.attributes?.Country}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default ListMemberTable;
